import { render, staticRenderFns } from "./appointorder.vue?vue&type=template&id=78abe006"
import script from "./appointorder.vue?vue&type=script&lang=js"
export * from "./appointorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports